import { Menu } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { Avatar } from '../components/ui/Avatar'
import { Badge } from '../components/ui/Badge'
import { useAuthStore } from '../stores/authStore'
import { useSidebarStore } from '../stores/sidebarStore'
import styles from './Header.module.css'

const TITOLI_PER_PATH: Record<string, string> = {
  '/app/dashboard':       'Dashboard',
  '/app/leads':           'Allenati',
  '/app/miei-lead':       'I miei Lead',
  '/app/sessioni':        'Sessioni',
  '/app/profilo':         'Profilo',
  '/app/abbonamento':     'Abbonamento',
  '/manager/dashboard':   'Dashboard team',
  '/manager/team':        'Membri team',
  '/manager/sessioni':    'Sessioni team',
  '/manager/leads':       'Lead team',
  '/manager/report':      'Report',
  '/admin/dashboard':     'Dashboard globale',
  '/admin/utenti':        'Utenti',
  '/admin/teams':         'Teams',
  '/admin/leads':         'Lead di Sistema',
  '/admin/revenue':       'Revenue',
  '/admin/costi-ai':      'Costi AI',
  '/admin/audit-log':     'Audit log',
}

function titoloPerPath(p: string): string {
  if (TITOLI_PER_PATH[p]) return TITOLI_PER_PATH[p]
  // Match prefissi per route con :id
  if (p.startsWith('/app/sessioni/')) return 'Dettaglio sessione'
  if (p.startsWith('/admin/utenti/')) return 'Dettaglio utente'
  if (p.startsWith('/admin/teams/')) return 'Dettaglio team'
  return 'RingCoach'
}

export function Header() {
  const { utente } = useAuthStore()
  const { apriDrawer } = useSidebarStore()
  const { pathname } = useLocation()

  const titolo = titoloPerPath(pathname)

  if (!utente) return null

  return (
    <header className={styles.header}>
      <button className={styles.hamburger} onClick={apriDrawer} aria-label="Apri menu">
        <Menu size={20} />
      </button>

      <div className={styles.logoMobile}>
        Ring<strong>Coach</strong>
      </div>

      <h1 className={styles.titolo}>{titolo}</h1>

      <div className={styles.spacer} />

      <div className={styles.utente}>
        <div className={styles.utenteInfo}>
          <span className={styles.utenteNome}>
            {utente.nome} {utente.cognome}
          </span>
          <Badge variante={varianteRuolo(utente.ruolo)}>{utente.ruolo}</Badge>
        </div>
        <Avatar nome={utente.nome} cognome={utente.cognome} taglia="sm" />
      </div>
    </header>
  )
}

function varianteRuolo(r: string): 'accent' | 'info' | 'default' {
  if (r === 'superadmin') return 'accent'
  if (r === 'manager') return 'info'
  return 'default'
}
